import { useDispatch, useSelector } from "react-redux";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField, CircularProgress } from "@mui/material";
import { useEffect, forwardRef, Fragment } from "react";
import { LeaveStatus } from "../../app/slices/leaveStatusSlice";

export const SelectLeaveStatus = forwardRef((props, ref) => {
  const statusList = useSelector((state) => state.leaveStatus.data);
  const loading = useSelector((state) => state.leaveStatus.loading);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!statusList?.length) {
      dispatch(LeaveStatus.getAll());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Autocomplete
      ref={ref}
      options={statusList || []}
      {...props}
      getOptionLabel={(option) => option.name ?? ""}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={(params) => (
        <TextField
          {...params}
          label={props.label ?? "حالة الطلب"}
          size="small"
          required={props.required}
          error={props.error}
          helperText={props.helperText}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </Fragment>
            ),
          }}
        />
      )}
    />
  );
});
